"use client";

import { StockItem } from "../../types/stocks";
import { StocksGrid } from "./StockGrid";
import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";
import BFLLink from "@repo/shared-ui/BFLLink";

interface MostBroughtStocksClientProps {
  stocks: StockItem[];
  defaultImage: string;
  errorMessage?: string;
  stockNotFoundImgUrl: string;
  href?: string;
  openInNewTab?: boolean | string;
  label?: string;
  modalTitle?: string;
  modalBtnCta?: string;
  successMsg?: string;
  errorMsg?: string;
}

export const MostBroughtStocksClient = ({
  stocks,
  defaultImage,
  errorMessage,
  stockNotFoundImgUrl,
  href,
  openInNewTab,
  label,
  modalBtnCta,
  modalTitle,
  successMsg,
  errorMsg,
}: MostBroughtStocksClientProps) => {

  const handleCardClick = (stock: StockItem) => {
    const url = window.location?.href?.includes("stock-and-trading");
    const data = {
      section_title: componentNameConstants.MOST_BOUGHT_STOCKS,
      component: componentNameConstants.MOST_BOUGHT_STOCKS,
      event: dlEventConstants.CLICK,
      element: dlElementConstants.VIEW_ALL_CLICK,
      cta_text: componentNameConstants.MOST_BOUGHT_STOCKS,
      event_type: dlEventConstants.CARD_CLICK,
      destination_url: stock?.redirectURL,
    };

    const cleverTapObj = {
      EP_PAGE_NAME: dlElementConstants.TRADING_MALL_CLP,
      EP_TILE_CLICKED: stock.fullName,
      EP_JOURNEY_NAME: dlElementConstants.TRADING_MALL_CLP_EP,
    };
    dataLayer("", data, cleverTapObj);
  };

  const dlData = {
    section_title: componentNameConstants.MOST_BOUGHT_STOCKS,
    component: componentNameConstants.MOST_BOUGHT_STOCKS,
    event: dlEventConstants.CLICK,
    element: dlElementConstants.VIEW_ALL_CLICK,
    cta_text: dlElementConstants.VIEW_ALL_CLICK,
    event_type: dlEventConstants.BUTTON_CLICK,
    destination_url: href,
  };
  const cleverTapObj = {
    EP_PAGE_NAME: dlElementConstants.TRADING_MALL_CLP,
    EP_JOURNEY_NAME: dlElementConstants.TRADING_MALL_CLP_EP,
    EP_CTA: dlElementConstants.VIEW_ALL_CLICK,
    EP_TILE_CLICKED: ""
  };

  return (
    <>
      <StocksGrid
        stocks={stocks}
        defaultImage={defaultImage}
        errorMessage={errorMessage}
        stockNotFoundImgUrl={stockNotFoundImgUrl}
        modalTitle={modalTitle}
        modalBtnCta={modalBtnCta}
        successMsg={successMsg}
        errorMsg={errorMsg}
        onCardClick={handleCardClick}
        section_title="Most_Brought_Stocks"
        cta_text="most_bought_stocks"
      />

      <BFLLink openInNewTab={openInNewTab} href={href} ctProps={JSON.stringify(cleverTapObj)} dlProps={JSON.stringify(dlData)}>
        <div className="mt-[8px] max-w-fit cursor-pointer border-0 bg-transparent px-0 pb-[4px] pt-[8px] text-left transition-opacity duration-200 ease-linear">
          <button
            type="button"
            className="text-link-primary h-[18px] cursor-pointer font-[500] text-[16px]"
          >
            {label}
          </button>
        </div>
      </BFLLink>
    </>

  );
};
